import {useCurrentUser} from "~/hooks";
import AccountHeader from "../components/AccountHeader";
import AccountFormInfo from "../components/Forms/AccountFormInfo";
import AccountPlanCard from "../components/AccountPlanCard";

function AccountInfo() {

	const currentUser = useCurrentUser();

	return (
		<div className="container">
			<AccountHeader active={'info'} />
			<AccountFormInfo currentUser={currentUser} />
			<AccountPlanCard />
		</div>
	)
}

export default AccountInfo;
